import script from "./ProjectSportingActivities.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectSportingActivities.vue?vue&type=script&setup=true&lang=js"

import "./ProjectSportingActivities.vue?vue&type=style&index=0&id=185a1116&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-185a1116"]])

export default __exports__